import {
  MuiToggleButton,
  MuiToggleButtonGroup,
} from './styles/customToggleButton';

const CustomToggleButton = ({ handleValues, values, toggleItems, exclusive=false  }) => {
  return (
      <MuiToggleButtonGroup
      value={values}
      onChange={handleValues}
      exclusive={exclusive}
      itemsCount={toggleItems.length}
      >
          { toggleItems.map( btn => (
              <MuiToggleButton value={btn.value}>
                  { btn.icon }
              </MuiToggleButton>
          )) }
      </MuiToggleButtonGroup>
  );
};

export default CustomToggleButton;
